import {Action, ActionReducerMap} from '@ngrx/store';
import {EditState} from './EditState';
import { editUiReducer } from './editUi/reducer';
import {Service} from '../../store/service/Service';

export const GO_TO_PROFILE = '[edit] Activate Service';

export const editReducer: ActionReducerMap<EditState> = {
  editUi: editUiReducer,
};

export class GoToProfileAction implements Action {
  readonly type = GO_TO_PROFILE;

  constructor(public payload: Service) {}
}
